<script lang="ts">
  import { Form, Image, Input } from "sveltestrap";
  import data from "../../../../Data/Chat/Chat.json";
  import { selectList } from "../../../../store";
  let imgPath: string = "/assets/images/user";
  let array = data.pepolelistdata;
  // for search value
  const handleSearchKeyword = (keyword: string) => {
    if (keyword == "") {
      return array = data.pepolelistdata
    } else {
      const keywords = keyword.toLowerCase();
      array = array.filter(
        (member) => member.name.toLowerCase().indexOf(keywords) > -1);
    }
  };
  const handleList = (list) => {
    selectList.update((value) => (value = [list]));
  };
</script>

<div class="people-list" id="people-list">
  <div class="search">
    <Form class="theme-form">
      <div class="mb-3">
        <Input
          type="text"
          placeholder="search"
          on:input={(e) => handleSearchKeyword(e.target.value)}
        />
        <i class="fa fa-search" />
      </div>
    </Form>
  </div>
  <ul class="list">
    {#each array as chatItem}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li class="clearfix" on:click={() => handleList(chatItem)}>
        <Image
          class="rounded-circle user-image"
          src="{imgPath}/{chatItem.img}"
          alt=""
        />
        <div class="status-circle {chatItem.class}" />
        <div class="about">
          <div class="name">{chatItem.name}</div>
          <div class="status">{chatItem.status}</div>
        </div>
      </li>
    {/each}
  </ul>
</div>
